<template>
  <div class="container">
    <!-- <h2>注册成为新的商户</h2>
    <p class="tips">注册成为新的商户 如果你还不是捷算的商户</p> -->
    <div class="list">
      <el-row :gutter="26">
        <el-col :span="8" v-for="(item, index) in itemList" :key="index">
          <div class="item" @click="changePageHandle(item.path,item.code,item.id)">
            <img :src="item.logoPathUrlList&&item.logoPathUrlList[0]" alt width="90px" height="90px"/>
            <div class="title">{{item.platformName}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
// import { getRecordInfo } from "@/api/user";
// import { getToken } from '@/utils/auth'
import Cookie from "js-cookie";

export default {
  name: "adminRegister",
  data() {
    return {
      platformId:'',
      itemList: [
        // {
        //   title: "惠百色商城",
        //   icon: require("@/assets/img/sign1.png"),
        //   path: "adminRegister/mallRegister",
        //   code: 41000
        // },
        // {
        //   title: "学校报名缴费",
        //   icon: require("@/assets/img/sign2.png"),
        //   path: "adminRegister/schoolRegister",
        //   code: 12345
        // },
        // {
        //   title: "开卡通用",
        //   icon: require("@/assets/img/sign3.png"),
        //   path: "adminRegister/openCardRegister",
        //   code: 99999
        // },
        //   {
        //   platformName: "运营商注册",
        //   logoPathUrlList: [require("@/assets/img/sign4.png")],
        //   path: "adminRegister/OperatorRegistration",
        //   code: 7777777
        // },
        //  {
        //   title: "企业管理员",
        //   icon: require("@/assets/img/sign4.png"),
        //   path: "adminRegister/enterpriseAdmins",
        //   code: 7777777
        // },
        // {
        
        //   title: "商城注册",
        //   icon: require("@/assets/img/sign5.png"),
        //   path: "adminRegister/enterpriseBusinessRegister",
        //   code: 666666
      
        // },
        //  {
        //   title: "企业商家",
        //   icon: require("@/assets/img/sign5.png"),
        //   path: "adminRegister/enterpriseBusiness",
        //   code: 666666
        // },
        //  {
        //   title: "个人商家",
        //   icon: require("@/assets/img/sign6.png"),
        //   path: "adminRegister/personBusiness",
        //   code: 55555
        // },
      ]
    };
  },
  created() {
    this.getList()
    // this.isCheckRecird()
    console.log(process);
  },
  methods: {
    //判断操作步骤
    isCheckRecird(path) {
      
      this.$request
        .post("/approver-api/api/web/approvetenantinformation/record")
        .then(res => {
          console.log(res);
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }

          if (res.data) {
            this.$router.push({
              path,
              query: { record: res.data.record, approveId: res.data.approveId,platformId:this.platformId }
            });
          } else {
            this.$router.push({
              path,
              query: { record: 0,platformId:this.platformId }
            });
          }
        });
    },
    //判断是否注册过
    changePageHandle(path, code,id) {
      this.platformId=id
      this.$request
        .post("/approver-api/api/web/approvetenantinformation/register", {
          tenantCode: code,platformId:id
        })
        .then(res => {
          console.log(res);
          if (res.code == 10050) {
            if (res.data.tenantCode == code || res.data.tenantCode == "") {
              window.location.href = res.data.url + "?token=" + res.data.token;

              Cookie.set("token", res.data.token);
            } else {
              return this.$message.error("该账号身份不匹配!");
            }
          } else {
            this.isCheckRecird(path);
          }
        });
    },
    getList() {
      this.$request
        .post("/approver-api/api/web/platforminfo/page", {})
        .then(res => {
            let arr = res.data.list.map(x=>{
              x.code=7777777
              x.path="adminRegister/OperatorRegistration"
              return x
            });
            this.itemList = [...this.itemList,...arr]
        });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 928px;
  margin: 0 auto;
  padding-top: 50px;
  h2 {
    margin: 0;
  }
  .tips {
    color: #595a60;
    padding-bottom: 20px;
  }
  .list {
    margin-bottom: 60px;
    .item {
      text-align: center;
      position: relative;
      padding-top: 75px;
      color: #2c2d2f;
      width: 292px;
      height: 292px;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 7px;
      transition: all 0.1s linear;
      border: 3px solid #fff;
      box-shadow: 0px 2px 8px 0px rgba(244, 244, 246, 1);
      margin-bottom:20px;
      cursor: pointer;
      &:hover {
        border-color: rgb(178, 199, 255);
        transform: translateY(-5px);
      }
      .title {
        padding-top: 22px;
      }
    }
  }
}
</style>
